<template>
	<div class="question-container">
		<div>
			<div
				class="question-text"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>
			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>
			<div class="input-text">
				<div class="date-container">
					<div class="year">
						<InputDropdown
							v-model:saturn="year"
							:list="yearList"
							:nothingSelected="localization.miscellaneous.selectYear[data.language]"
							:invalid="v$.year.$invalid"
						>
							<template #validation>
								<div v-if="false">Date year is required</div>
							</template>
						</InputDropdown>
					</div>

					<div
						class="month"
						v-if="showMonth"
					>
						<InputDropdown
							v-model:saturn="month"
							:list="monthList"
							:valueMap="month => month.value"
							:text="month => month.text"
							:nothingSelected="localization.miscellaneous.selectMonth[data.language]"
							:invalid="v$.month.$invalid"
						>
							<template #validation>
								<div v-if="false">Date month is required</div>
							</template>
						</InputDropdown>
					</div>
					<div
						class="day"
						v-if="showDay"
					>
						<InputDropdown
							v-model:saturn="day"
							:list="dayList"
							:nothingSelected="localization.miscellaneous.selectDay[data.language]"
							:invalid="v$.day.$invalid"
						>
							<template #validation>
								<div v-if="false">Date day is required</div>
							</template>
						</InputDropdown>
					</div>
				</div>
			</div>
		</div>
		<div class="question-continue-button">
			<button
				class="button"
				:style="{
					background: theme[answer.style.background],
					color: theme[answer.style.text],
				}"
				@click="answer.actions(getValueToSave(), [], data.question, toggleLoading, saveApplicationAction)"
				:disabled="!data.question.isValidationsMet(answer, v$)"
			>
				{{ data.question.getLocalizationDisplay(answer.label, data.language) }}
			</button>
		</div>
	</div>
</template>

<script>
	import LOCALIZATION from '@core/classes/Localization';
	import InputDropdown from '@/components/customerApp/InputDropdown.vue';
	import moment from 'moment';
	import { useVuelidate } from '@vuelidate/core';

	export default {
		name: 'QuestionDate',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				year: '',
				month: null,
				day: '',
				answer: null,
				yearList: [],
				monthList: [],
				dayList: [],
				listOfKeysToWatch: [
					'providemovedindate', // current residence
					'providepreviousmovedindate', // previous residence
					'providecurrentemployerstarteddate', // current employer
					'providepreviousemployerstarteddate', // previous employer
					'providemilitarycurrentemployerstarteddate', // current military
					'providemilitarypreviousemployerstarteddate', // previous military
					'rebateacademicenrollmentdate', // current school
					'rebateacademicgraduationdate', // school graduation
				],
			};
		},
		computed: {
			localization() {
				return LOCALIZATION;
			},
			showDay() {
				return this.data.question.showDay();
			},
			showMonth() {
				return this.data.question.showMonth();
			},
		},
		created() {
			let savedDate = this.data.question.savedAnswer;
			if (savedDate) {
				savedDate = moment(savedDate, ['YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]', 'YYYY-MM-DD']);

				this.year = Number(savedDate.year());
				this.month = Number(savedDate.month() + 1);
				this.day = Number(savedDate.date());
			}

			this.answer = this.data.question.getAnswers()[0];
			this.populateDropdownOptions();
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
					this.populateDropdownOptions();
				},
				{ deep: true },
			);
		},
		validations() {
			if (this.data.question.GetValidation) {
				return this.data.question.GetValidation();
			}
		},
		//validations() {
		//    const validations = {
		//        day: {},
		//        month: {},
		//        year: {}
		//    }

		//    if (this.answer.isValidationRequired) {
		//        validations.year = { required };

		//        if (this.showDay) {
		//            validations.day = { required };
		//        }

		//        if (this.showMonth) {
		//            validations.month = { required };
		//        }
		//    }

		//    return validations;
		//},
		methods: {
			getValueToSave() {
				const valuePieces = [this.year];

				if (this.showMonth) {
					valuePieces.push(this.month);
				}

				if (this.showDay) {
					valuePieces.push(this.day);
				}

				return moment(valuePieces.join('-'), ['YYYY-M-D', 'YYYY-M']).format('YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]');
			},
			cantDaysInMonth() {
				return moment(this.year + '-' + this.month, 'YYYY-M').daysInMonth();
			},
			populateDropdownOptions() {
				//Populate Months
				this.populateMonthList();

				this.$watch(
					() => this.year,
					(newValue, oldValue) => {
						if (
							this.data.question.key &&
							//Rebates Section
							(this.data.question.key.toLowerCase().includes('rebateacademicenrollmentdate') ||
								this.data.question.key.toLowerCase().includes('rebateacademicgraduationdate') ||
								this.data.question.key.toLowerCase().includes('rebatemilitaryenrollmentdateself') ||
								this.data.question.key.toLowerCase().includes('rebatemilitaryenrollmentdatespouse') ||
								//Credit Section
								this.data.question.key.toLowerCase().includes('providemovedindate') ||
								this.data.question.key.toLowerCase().includes('providemilitarycurrentemployerstarteddate') ||
								this.data.question.key.toLowerCase().includes('providecurrentemployerstarteddate') ||
								this.data.question.key.toLowerCase().includes('providebusinessstartdate') ||
								this.data.question.key.toLowerCase().includes('providepreviousmovedindate') ||
								this.data.question.key.toLowerCase().includes('providemilitarypreviousemployerstarteddate') ||
								this.data.question.key.toLowerCase().includes('providepreviousemployerstarteddate') ||
								this.data.question.key.toLowerCase().includes('providenonemployedstatusstartdate')) &&
							(newValue == this.yearList[0] || oldValue == this.yearList[0])
						) {
							this.month = null;
							this.monthList = [];
							this.populateMonthList();
						}
					},
				);

				//Populate Years
				this.populateYearList();

				//Populate Days
				if (this.showDay) {
					if (this.year && this.month) {
						this.populateDayList();
					}

					this.$watch(
						() => this.year,
						() => {
							this.day = '';
							this.dayList = [];
							if (this.month) {
								this.populateDayList();
							}
						},
					);

					this.$watch(
						() => this.month,
						() => {
							this.day = '';
							this.dayList = [];
							if (this.year) {
								this.populateDayList();
							}
						},
					);
				} else {
					this.day = 1;
				}
			},
			populateYearList() {
				if (this.data.question.key && this.data.question.key.toLowerCase().includes('birth')) {
					this.yearList = Array.from({ length: 100 }, (_, i) => moment().subtract(18, 'y').year() - i);
				}
				//Handle expiration dates
				else if (this.data.question.key && this.data.question.key.toLowerCase().includes('expiration')) {
					this.yearList = Array.from({ length: 40 }, (_, i) => moment().year() - 20 + i);
				}
				//Handle previous moved in date
				else if (this.data.question.key && this.data.question.key.toLowerCase().includes('providepreviousmovedindate')) {
					this.yearList = Array.from(
						{ length: 120 },
						(_, i) =>
							moment(
								this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate,
								'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]',
							).year() - i,
					);
				}
				//Handle previous start dates
				else if (
					this.data.question.key &&
					(this.data.question.key.toLowerCase().includes('providemilitarypreviousemployerstarteddate') ||
						this.data.question.key.toLowerCase().includes('providepreviousemployerstarteddate'))
				) {
					this.yearList = Array.from({ length: 120 }, (_, i) => this.getCurrentStatusStartDateYear().year() - i);
				} else {
					this.yearList = Array.from({ length: 120 }, (_, i) => moment().year() - i);
				}
			},
			populateMonthList() {
				//Handle enrollment, graduation, current moved in and start dates
				if (
					this.data.question.key &&
					//Rebates Section
					(this.data.question.key.toLowerCase().includes('rebateacademicenrollmentdate') ||
						this.data.question.key.toLowerCase().includes('rebateacademicgraduationdate') ||
						this.data.question.key.toLowerCase().includes('rebatemilitaryenrollmentdateself') ||
						this.data.question.key.toLowerCase().includes('rebatemilitaryenrollmentdatespouse') ||
						//Credit Section
						this.data.question.key.toLowerCase().includes('providemovedindate') ||
						this.data.question.key.toLowerCase().includes('providemilitarycurrentemployerstarteddate') ||
						this.data.question.key.toLowerCase().includes('providecurrentemployerstarteddate') ||
						this.data.question.key.toLowerCase().includes('providenonemployedstatusstartdate') ||
						this.data.question.key.toLowerCase().includes('providebusinessstartdate')) &&
					this.year == moment().format('yyyy')
				) {
					this.monthList = this.localization.miscellaneous.months[this.data.language];
					const currentMonthIndex = moment().format('M') - 1;
					this.monthList = this.monthList.slice(0, currentMonthIndex + 1);
				}
				//Handle previous moved in date
				else if (
					this.data.question.key &&
					this.data.question.key.toLowerCase().includes('providepreviousmovedindate') &&
					this.year ==
						moment(
							this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate,
							'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]',
						).format('yyyy')
				) {
					this.monthList = this.localization.miscellaneous.months[this.data.language];
					const currentMonthIndex = moment(
						this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.movedInDate,
						'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]',
					).format('M');
					this.monthList = this.monthList.slice(0, currentMonthIndex);
				}
				//Handle previous start dates
				else if (
					this.data.question.key &&
					(this.data.question.key.toLowerCase().includes('providemilitarypreviousemployerstarteddate') ||
						this.data.question.key.toLowerCase().includes('providepreviousemployerstarteddate')) &&
					this.year ==
						moment(
							this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate,
							'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]',
						).format('yyyy')
				) {
					this.monthList = this.localization.miscellaneous.months[this.data.language];
					const currentMonthIndex = moment(
						this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate,
						'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]',
					).format('M');
					this.monthList = this.monthList.slice(0, currentMonthIndex);
				} else {
					this.monthList = this.localization.miscellaneous.months[this.data.language];
				}
			},
			populateDayList() {
				this.dayList = Array.from({ length: this.cantDaysInMonth() }, (_, i) => i + 1);
			},
			getCurrentStatusStartDateYear() {
				if (this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate) {
					return moment(this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.currentEmployment.startDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]');
				} else {
					return moment(this.data.application.quoteAppData.applicationsDataAnswered.personalInfo.nonEmployedStatusStartDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]');
				}
			},
		},
		components: {
			InputDropdown,
		},
	};
</script>

<style></style>
